/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_Q5Inputs */

const en_simple_oto_faq_q5 = /** @type {(inputs: Simple_Oto_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does it cost?`)
};

const id_simple_oto_faq_q5 = /** @type {(inputs: Simple_Oto_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berapa biayanya?`)
};

/**
* | output |
* | --- |
* | "What does it cost?" |
*
* @param {Simple_Oto_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_q5 = /** @type {((inputs?: Simple_Oto_Faq_Q5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_Q5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_q5(inputs)
	return en_simple_oto_faq_q5(inputs)
});